import mxCitiesByState from "@/helpers/mxCitiesByState.json";
import mxStates from "@/helpers/mxStates.json";
export { mxCitiesByState, mxStates };

export const formatDateFromSF = (day) => {
  const dayText = (day || "00/00/00 00:00+0000").replace(/\+[\d]+/, "+0600");
  if (!dayText.includes("+0600")) {
    const timezoneOffset = /GMT(.*?)\s/.exec(new Date().toTimeString())[1];
    return new Date(`${dayText} 00:00${timezoneOffset}`);
  }
  return new Date(`${dayText}`); // Returns invalid date if day is undefined or null, even if dayText is set to "00/00/00 00:00+0600"
};

export function formatDate(date) {
  if (!date) return null;
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
}

export function formatDateDisplay(date) {
  if (date?.toString() === "Invalid Date") return "";
  const result =
    date?.toLocaleDateString?.("es-MX", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }) ||
    formatDate(date) ||
    "";
  return result;
}
